import React from 'react';
import { ArrowLink } from '../../../../../../ui';
import { useHandleClickFullAmend } from '../helpers/useHandleClickFullAmend';
import { StyledAction } from './StyledAction';
import { useFullAmendUrl } from '../helpers/useFullAmendUrl';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { ErrorBar } from '../../../../../shared/components';
import { IBooking } from '../../../../domain/booking/models/IBooking';

interface IFullAmendLinkProps {
	booking: IBooking;
}

export const FullAmendAction = ({ booking }: IFullAmendLinkProps) => {
	const url = useFullAmendUrl();
	const { handleClickFullAmend, isFullAmendUnavailable } =
		useHandleClickFullAmend(booking, url);
	const { t } = useTranslation();

	return (
		<>
			<StyledAction>
				<ArrowLink href={url} onClick={handleClickFullAmend}>
					{t('parking_booking_details_modify_booking_link')}
				</ArrowLink>
			</StyledAction>
			{isFullAmendUnavailable && (
				<ErrorBar>
					{t('web_parking_booking_details_cancel_amend_unavailable_error')}
				</ErrorBar>
			)}
		</>
	);
};
